import { render, staticRenderFns } from "./editRecordDialog.vue?vue&type=template&id=33ce5ba3&scoped=true&"
import script from "./editRecordDialog.vue?vue&type=script&lang=js&"
export * from "./editRecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./editRecordDialog.vue?vue&type=style&index=0&id=33ce5ba3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce5ba3",
  null
  
)

export default component.exports